export enum LoginPageTestIds {
  LOGIN_EMAIL = 'login-email',
  LOGIN_PASSWORD = 'login-password',
  ENTER_BUTTON = 'enter-button',
  FEDERATED_LOGIN_BUTTON = 'federated-login-button',
  PUBLIC_LOGIN_BUTTON = 'public-login-button',
  ENTER_WITH_EMAIL_BUTTON = 'enter-with-email-button',
  OAUTH_EMAIL_CONTINUE_BUTTON = 'oauth-email-continue-button',
  OAUTH_BACK_TO_EMAIL_BUTTON = 'oauth-back-to-email-button',
  OAUTH_CONSENT_ALLOW_BUTTON = 'oauth-consent-allow-button',
  OAUTH_CONSENT_DENY_BUTTON = 'oauth-consent-deny-button',
}
